<i18n src="@/locales/modules/DepartmentTranslate.json"></i18n>

<template>
	<div>
		<el-dialog class="custom-dialog todo-detail-dialog" append-to-body destroy-on-close :visible.sync="isSidebarActiveLocal">
			<div slot="title" class="flex justify-between items-center w-full">
				<span class="el-dialog__title break-normal">{{ $t("DetailDepartment") }}</span>
				<DepartmentContextMenu
					class="mr-2"
					:node="department"
					:department="data"
					@onClickEdit="data => $emit('onClickEdit', data)"
					@onClickDelete="data => $emit('onClickDelete', data)"
					@onClickManageTitle="data => $emit('onClickManageTitle', data)"
				/>
			</div>
			<div>
				<div class="p-6 pb-0" v-if="data">
					<div>
						<vs-row class="mb-1">
							<vs-col vs-w="4">
								<label class="text-solid-gray-1 text-base">{{ $t("DepartmentName") }}:</label>
							</vs-col>
							<vs-col vs-w="8" class="text-black text-base">{{ department.name }}</vs-col>
						</vs-row>
						<vs-row class="mb-1">
							<vs-col vs-w="4">
								<label class="text-solid-gray-1 text-base">{{ `${$t("Code")} ${$t("Department").toLowerCase()}` }}:</label>
							</vs-col>
							<vs-col vs-w="8" class="text-black text-base">{{ data.code }}</vs-col>
						</vs-row>
						<vs-row class="mb-1">
							<vs-col vs-w="4">
								<label class="text-solid-gray-1 text-base">{{ $t("BelongTo") }}:</label>
							</vs-col>
							<vs-col vs-w="8" class="text-black text-base">{{ data.name }}</vs-col>
						</vs-row>
						<vs-row class="mb-1">
							<vs-col vs-w="4">
								<label class="text-solid-gray-1 text-base">{{ $t("Description") }}:</label>
							</vs-col>
							<vs-col vs-w="8" class="text-black text-base">{{ $helper.numFormat(data.debt_limit) }}</vs-col>
						</vs-row>
					</div>
					<!-- List Titles -->
					<div v-if="department.titles && department.titles.length > 0">
						<label class="text-solid-gray-1">{{ $t("List") }} {{ $t("Title").toLowerCase() }}:</label>
						<vs-table :data="department.titles" class="stack-table mt-5">
							<template slot-scope="{ data }">
								<vs-tr :key="indextr" v-for="(tr, indextr) in data">
									<vs-td :data="data[indextr].username">
										{{ data[indextr].name }}
									</vs-td>

									<vs-td :data="data[indextr].id">
										{{ data[indextr].role && data[indextr].role.name }}
									</vs-td>
								</vs-tr>
							</template>
						</vs-table>
					</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import DepartmentContextMenu from "./DepartmentContextMenu";

export default {
	name: "DepartmentDetailDialog",
	components: { DepartmentContextMenu },
	props: {
		isSidebarActive: {
			type: Boolean,
			required: true
		},
		department: {
			type: Object,
			default: () => {}
		}
	},

	data() {
		return {
			activeGeneral: ["GeneralInfo"],
			debts: [],
			page: 1,
			limitPerPage: 10
		};
	},
	computed: {
		isSidebarActiveLocal: {
			get() {
				return this.isSidebarActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeSidebar");
				}
			}
		},

		data() {
			return this.$store.getters["departmentManagement/getDepartment"](this.department.id);
		}
	},

	methods: {
		handleSort() {}
	}
};
</script>
<style lang="scss">
.el-radio-button__inner {
	width: 100%;
	border: none;
	border-radius: 0 0 0 0 !important;
}
[dir] .el-radio-button__inner {
	background: #e0e0e0;
}
</style>
